export const getLsKey = (key = '') => {
  if (typeof window === 'undefined') {
    return false;
  }

  return localStorage.getItem(key);
};
